/* eslint-disable operator-linebreak */
import axios from 'axios';

const timeout = process.env.NODE_ENV === 'development' ? 1500000 : 1800000;
const api = axios.create({
  Accept: 'application/*',
  timeout,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_X_API_KEY_HEADER,
  },
  withCredentials: false,
  responseType: 'json',
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

const tokenHeaders = (useToken) => {
  const token = localStorage.getItem('userToken');
  const headers =
    useToken && token ? { headers: { Authorization: `${token}` } } : {};
  return headers;
};

export const get = async (url, useToken) => {
  const headers = tokenHeaders(useToken);
  const response = await api.get(url, headers);
  return response;
};

export const post = async (url, data, useToken) => {
  const headers = tokenHeaders(useToken);
  const response = await api.post(url, data, headers);
  return response;
};

export const put = async (url, data, useToken) => {
  const headers = tokenHeaders(useToken);
  const response = await api.put(url, data, headers);
  return response;
};
// Note: delete is a reserved word
export const remove = async (url, useToken) => {
  const headers = tokenHeaders(useToken);
  const response = await api.delete(url, headers);
  return response;
};
